/**
 * Enough rows that most sections fit on one page, and no pager at all when they do. Everything
 * else (the range label, the placement) comes from the Table's own defaults.
 */
export const CONFIG_PAGINATION = { pageSize: 100, showSizeChanger: false, hideOnSinglePage: true } as const;

/**
 * A height on `y` is what splits the header from the body, so the header stays put while the rows
 * scroll. Without it both live in one scrolling box and the header scrolls away with the rows.
 * The subtraction covers the top bar, the page padding, the title, the actions bar and the pager.
 */
export const CONFIG_SCROLL = { x: 'max-content', y: 'calc(100vh - 296px)' } as const;
